import useUrl from './helpers/useUrl'

export default (client) => {
  const root = useUrl('v4/custom-chance')

  return {
    getHalloweenBonus() {
      const url = root('')
      return client.get(url)
    },
    openHalloweenBonus() {
      const url = root('/open')
      return client.post(url)
    },
  }
}
